var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      staticClass: "numbers-settings-modal",
      attrs: {
        visible: _vm.visible,
        title: "Sayı Ayarları - " + _vm.widget.title,
        width: "600px",
        footer: null,
        destroyOnClose: true,
      },
      on: {
        cancel: function ($event) {
          return _vm.$emit("close")
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "settings-container" },
        [
          _c("div", { staticClass: "header-section" }, [
            _c(
              "div",
              { staticClass: "left-actions" },
              [
                _c("a-input-search", {
                  staticStyle: { width: "250px" },
                  attrs: { placeholder: "Ara...", allowClear: "" },
                  on: { search: _vm.handleSearch },
                  model: {
                    value: _vm.searchQuery,
                    callback: function ($$v) {
                      _vm.searchQuery = $$v
                    },
                    expression: "searchQuery",
                  },
                }),
                _vm._v(" "),
                _c(
                  "a-popover",
                  {
                    attrs: {
                      placement: "bottomLeft",
                      trigger: "click",
                      overlayClassName: "table-filter-popover",
                    },
                    model: {
                      value: _vm.filterVisible,
                      callback: function ($$v) {
                        _vm.filterVisible = $$v
                      },
                      expression: "filterVisible",
                    },
                  },
                  [
                    _c(
                      "template",
                      { slot: "content" },
                      [
                        _c("TableFilter", {
                          attrs: { fields: _vm.fields, value: _vm.filters },
                          on: { input: _vm.onFiltersUpdated },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "SupsisButton",
                      {
                        attrs: {
                          classNames:
                            "" +
                            (_vm.filters.length > 0 ? "active-filters" : ""),
                        },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("filter_alt"),
                        ]),
                        _vm._v(
                          "\n                        Filtre\n                        "
                        ),
                        _vm.filters.length > 0
                          ? _c("span", { staticClass: "filter-count" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.filters.length) +
                                  "\n                        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.filters.length
                          ? _c(
                              "i",
                              {
                                staticClass: "material-icons clear-filters",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.clearFilters.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [_vm._v("close")]
                            )
                          : _vm._e(),
                      ]
                    ),
                  ],
                  2
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("a-divider", { staticStyle: { margin: "12px 0" } }),
          _vm._v(" "),
          _c(
            "a-form",
            { attrs: { form: _vm.form, layout: "vertical" } },
            [
              _c(
                "a-form-item",
                { attrs: { label: "Veri Kaynağı" } },
                [
                  _c(
                    "a-radio-group",
                    {
                      attrs: { "button-style": "solid" },
                      model: {
                        value: _vm.dataSource,
                        callback: function ($$v) {
                          _vm.dataSource = $$v
                        },
                        expression: "dataSource",
                      },
                    },
                    [
                      _c("a-radio-button", { attrs: { value: "count" } }, [
                        _vm._v("Kayıt Sayısı"),
                      ]),
                      _vm._v(" "),
                      _c("a-radio-button", { attrs: { value: "fields" } }, [
                        _vm._v("Alan Seçimi"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.dataSource === "fields"
                ? [
                    _c(
                      "a-form-item",
                      { attrs: { label: "Sayısal Alan(lar)" } },
                      [
                        _c(
                          "a-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              mode: "multiple",
                              placeholder: "Alan seçiniz",
                            },
                            model: {
                              value: _vm.previewSettings.fields,
                              callback: function ($$v) {
                                _vm.$set(_vm.previewSettings, "fields", $$v)
                              },
                              expression: "previewSettings.fields",
                            },
                          },
                          _vm._l(_vm.numericFields, function (field) {
                            return _c(
                              "a-select-option",
                              { key: field._id, attrs: { value: field._id } },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(field.name) +
                                    "\n                        "
                                ),
                              ]
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a-form-item",
                      { attrs: { label: "Hesaplama Tipi" } },
                      [
                        _c(
                          "a-radio-group",
                          {
                            attrs: { "button-style": "solid" },
                            model: {
                              value: _vm.previewSettings.calculationType,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.previewSettings,
                                  "calculationType",
                                  $$v
                                )
                              },
                              expression: "previewSettings.calculationType",
                            },
                          },
                          [
                            _c("a-radio-button", { attrs: { value: "sum" } }, [
                              _vm._v("Toplam"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "a-radio-button",
                              { attrs: { value: "average" } },
                              [_vm._v("Ortalama")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a-radio-button",
                              { attrs: { value: "median" } },
                              [_vm._v("Medyan")]
                            ),
                            _vm._v(" "),
                            _c("a-radio-button", { attrs: { value: "min" } }, [
                              _vm._v("Minimum"),
                            ]),
                            _vm._v(" "),
                            _c("a-radio-button", { attrs: { value: "max" } }, [
                              _vm._v("Maksimum"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "preview-and-format" }, [
                _c("div", { staticClass: "preview-section" }, [
                  _c("div", { staticClass: "preview-label" }, [
                    _vm._v("Önizleme:"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "preview-value" },
                    [
                      _vm.unitValue
                        ? [
                            _vm.previewSettings.customization.unit.position ===
                            "left"
                              ? _c("span", { staticClass: "unit" }, [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(_vm.unitValue) +
                                      "\n                            "
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "value",
                          style: { color: _vm.valueColor },
                        },
                        [_vm._v(_vm._s(_vm.formattedPreviewValue))]
                      ),
                      _vm._v(" "),
                      _vm.unitValue
                        ? [
                            _vm.previewSettings.customization.unit.position ===
                            "right"
                              ? _c("span", { staticClass: "unit" }, [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(_vm.unitValue) +
                                      "\n                            "
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "decimal-format" }, [
                  _c(
                    "div",
                    { staticClass: "decimal-buttons" },
                    [
                      _c(
                        "a-button",
                        {
                          staticClass: "decimal-button",
                          attrs: {
                            disabled: _vm.previewSettings.decimalFormat <= 0,
                          },
                          on: { click: _vm.decreaseDecimal },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("remove"),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a-button",
                        {
                          staticClass: "decimal-button",
                          attrs: {
                            disabled: _vm.previewSettings.decimalFormat >= 10,
                          },
                          on: { click: _vm.increaseDecimal },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("add"),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "decimal-value" }, [
                    _vm._v(
                      "Ondalık: " + _vm._s(_vm.previewSettings.decimalFormat)
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "unit-settings-container" }, [
                _c("div", { staticClass: "unit-row" }, [
                  _c("div", { staticClass: "setting-label" }, [
                    _vm._v("Birim:"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "setting-content" },
                    [
                      _c(
                        "a-radio-group",
                        {
                          attrs: {
                            value: _vm.selectedUnit,
                            "button-style": "solid",
                          },
                        },
                        [
                          _c(
                            "a-radio-button",
                            {
                              attrs: { value: "none" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleUnitChange("none")
                                },
                              },
                            },
                            [_vm._v("Birim Yok")]
                          ),
                          _vm._v(" "),
                          _c(
                            "a-radio-button",
                            {
                              attrs: { value: "$" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleUnitChange("$")
                                },
                              },
                            },
                            [_vm._v("$")]
                          ),
                          _vm._v(" "),
                          _c(
                            "a-radio-button",
                            {
                              attrs: { value: "€" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleUnitChange("€")
                                },
                              },
                            },
                            [_vm._v("€")]
                          ),
                          _vm._v(" "),
                          _c(
                            "a-radio-button",
                            {
                              attrs: { value: "₺" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleUnitChange("₺")
                                },
                              },
                            },
                            [_vm._v("₺")]
                          ),
                          _vm._v(" "),
                          _c(
                            "a-radio-button",
                            {
                              attrs: { value: "custom" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleUnitChange("custom")
                                },
                              },
                            },
                            [_vm._v("Özel")]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.selectedUnit === "custom"
                        ? _c("a-input", {
                            staticStyle: { width: "120px" },
                            attrs: { placeholder: "Özel birim" },
                            on: { change: _vm.handleCustomUnitChange },
                            model: {
                              value: _vm.customUnit,
                              callback: function ($$v) {
                                _vm.customUnit = $$v
                              },
                              expression: "customUnit",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "unit-row" }, [
                  _c("div", { staticClass: "setting-label" }, [
                    _vm._v("Birim Pozisyonu:"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "setting-content" },
                    [
                      _c(
                        "a-radio-group",
                        {
                          staticClass: "position-buttons",
                          attrs: {
                            "button-style": "solid",
                            disabled: _vm.selectedUnit === "none",
                          },
                          model: {
                            value:
                              _vm.previewSettings.customization.unit.position,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.previewSettings.customization.unit,
                                "position",
                                $$v
                              )
                            },
                            expression:
                              "previewSettings.customization.unit.position",
                          },
                        },
                        [
                          _c("a-radio-button", { attrs: { value: "left" } }, [
                            _vm._v("Solda"),
                          ]),
                          _vm._v(" "),
                          _c("a-radio-button", { attrs: { value: "right" } }, [
                            _vm._v("Sağda"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "unit-row" }, [
                  _c("div", { staticClass: "setting-label" }, [
                    _vm._v("Renk:"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "setting-content" },
                    [
                      _c("a-input", {
                        staticStyle: { width: "80px" },
                        attrs: { type: "color" },
                        model: {
                          value: _vm.previewSettings.customization.color,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.previewSettings.customization,
                              "color",
                              $$v
                            )
                          },
                          expression: "previewSettings.customization.color",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-actions" },
                [
                  _c(
                    "a-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.$emit("close")
                        },
                      },
                    },
                    [_vm._v("İptal")]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary", loading: _vm.saving },
                      on: { click: _vm.handleSave },
                    },
                    [_vm._v("Kaydet")]
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }